import { ActionTree } from 'vuex'
import * as types from './mutation-types'
import RootState from '@vue-storefront/core/types/RootState'
import CategoriesState from '../../types/CategoriesState'
import { processURLAddress } from '@vue-storefront/core/helpers'
import fetch from 'isomorphic-fetch'
import config from 'config'
import rootStore from '@vue-storefront/core/store'

// See tags/actions.ts - one fetch shared between overlapping callers per city.
let categoriesInFlight: { key: string, promise: Promise<any> } | null = null

const activeLocationCode = () => {
  const location = rootStore.getters['locations/getActiveLocation']
  return location ? location.code : null
}

const actions: ActionTree<CategoriesState, RootState> = {
  // Loads categories unless they're already loaded (or loading) for this city.
  ensureCategories ({ state, dispatch }, { locationCode = null } = {}) {
    const key = locationCode || activeLocationCode()
    if (key && state.loadedForLocationCode === key) {
      return Promise.resolve()
    }
    if (!categoriesInFlight || categoriesInFlight.key !== key) {
      const promise = dispatch('loadCategories', { locationCode: key }).finally(() => {
        if (categoriesInFlight && categoriesInFlight.promise === promise) {
          categoriesInFlight = null
        }
      })
      categoriesInFlight = { key, promise }
    }
    return categoriesInFlight.promise
  },
  async loadCategories ({commit}, payload = { locationCode: null }) {
    let url = processURLAddress(`${config.partners.base_endpoint}/list/categories`)
    let locationCode = payload.locationCode
    if (!locationCode) {
      let activeLocation = rootStore.getters['locations/getActiveLocation']
      if (activeLocation) {
        locationCode = activeLocation.code
      }
    }
    if (locationCode) {
      url = `${url}?locationCode=${locationCode}`
    }
    await fetch(url, { method: config.elasticsearch.queryMethod,
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => { return resp.json() })
      .then (response => {
        commit(types.SET_PARTNERS_CATEGORIES, response.result)
        commit(types.SET_CATEGORIES_LOADED_FOR_LOCATION, locationCode)
        return response
      })
      .catch(error => {
        commit(types.SET_PARTNERS_CATEGORIES, [])
        commit(types.SET_CATEGORIES_LOADED_FOR_LOCATION, null)
        throw new Error('FetchError in request to ES: ' + error.toString())
      })
  },
  setCurrentCategory ({ state, commit }, payload) {
    rootStore.dispatch('partners/resetCurrentPartner')
    let category = state.categories.find(cat => cat.code === payload)
    commit(types.SET_CURRENT_PARTNER_CATEGORY, category)
    let location = rootStore.getters['locations/getActiveLocation'].code
    if (category && category.entity_id) {
      return rootStore.dispatch('partner_tags/ensureTags', { categoryId: category.entity_id, locationCode: location })
    }
  },
  resetCurrentCategory ({ commit }) {
    commit(types.RESET_CURRENT_CATEGORY)
  }
}

export default actions
